import {
  PREFS_OPTED_OUT_COOKIE,
  PREFS_OPTED_OUT_VALUE,
} from "@/app/(discover)/jobs/[stateName]/(state-jobs)/components/filters/saved-search-and-preferences/preference-defaults.constants";
import { deleteCookie, getCookie, setSessionCookie } from "@/lib/cookies";

export function hasOptedOutOfPreferenceDefaults(): boolean {
  return getCookie(PREFS_OPTED_OUT_COOKIE) === PREFS_OPTED_OUT_VALUE;
}

export function setPreferenceDefaultsOptOut(optedOut: boolean): void {
  if (optedOut) {
    setSessionCookie(PREFS_OPTED_OUT_COOKIE, PREFS_OPTED_OUT_VALUE);
  } else {
    deleteCookie(PREFS_OPTED_OUT_COOKIE);
  }
}
